import axios from '@/libs/api.request';
import search from '@/libs/search';
import axiosRequest from 'axios';
import { getMasterUserList } from '@/api/modules/account-management/master-user-management';

export const getMainCategoryList = data => {
    return axios.request({
        url: 'api/productManagement/mainCategory/getMainCategoryList',
        data: data,
        method: 'post'
    });
};

export const saveMainCategory = data => {
    return axios.request({
        url: 'api/productManagement/mainCategory/saveMainCategory',
        data: data,
        method: 'post'
    });
};

export const getSubCategoryList = data => {
    return axios.request({
        url: 'api/productManagement/subCategory/getSubCategoryList',
        data: data,
        method: 'post'
    });
};

export const saveSubCategory = data => {
    return axios.request({
        url: 'api/productManagement/subCategory/saveSubCategory',
        data: data,
        method: 'post'
    });
};

export const pageInit4CategoryList = () => {
    const masterUserSearch = search.getSearchParams({ closeAllConditions: true });

    return axiosRequest.all([
        getMasterUserList(masterUserSearch)
    ]).then(axiosRequest.spread(function (master) {
        if (master.code === 0) {
            return {
                code: 0,
                message: '',
                data: {
                    master: master.data
                }
            };
        }
    }));
};

export const updateSubCategoryCustomerManager = data => {
    return axios.request({
        url: 'api/productManagement/subCategory/updateSubCategoryCustomerManager',
        data: data,
        method: 'post'
    });
};
